<ng-container *ngIf="(messages$ | async) as messages">
  <ng-container *ngFor="let message of messages; let i = index; trackBy: messageTrackBy">
    <div class="date" *ngIf="isShowMessageDate(messages[i - 1], messages[i])"
      >{{ message.createdAt * 1000 | date }}
    </div>
    <app-chat-dialog-message [message]="message" (rendered)="onMessageRendered(message)"> </app-chat-dialog-message>
  </ng-container>
</ng-container>
